import React, { Component } from "react";
import { Image } from "semantic-ui-react";
import _ from "lodash";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import getReportType from "./ReportType";
import Check from "../../assets/images/check.gif";
import HourGlass from "../../assets/images/hourglass.png";
import "../../assets/styles/bootstrap-table-extra.css";

class OfflineMvrReportTable extends Component {
  componentDidMount() {
    this.loadData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  redirectToLink = (offlineCrimCode) => {
    localStorage.offlineResultId = offlineCrimCode;
    localStorage.offlinePickedUser = this.props.pickedUser;
    this.props.history.push("/offline/dlsearch");
  };

  reportLink = (cell, row) => (
    <span
      role="button"
      tabIndex={0}
      className={"url-link-activity"}
      onClick={() =>
        this.redirectToLink(row.actId, row.actReportId, row.activityDescription)
      }
    >
      {row.activityDescription}
    </span>
  );

  dobFormat = (cell, row) => {
    const dobTokens = row.DateOfBirth.split("/");
    let year = "";
    if (row.DateOfBirth.length === 6 && dobTokens.length > 2) {
      year = `19${dobTokens[2]}`;
    } else if (dobTokens.length > 2) {
      year = dobTokens[2];
    }
    return <span className={"icon-align-middle"}>{year}</span>;
  };

  reportFormat = (cell, row) => (
    <span
      role="button"
      tabIndex={0}
      className={"url-link-activity"}
      onClick={() => this.redirectToLink(row.crimCode)}
    >
      {row.crimStatus === "r" ? (
        <Image src={Check} inline className={"icon-align-middle"} />
      ) : (
        <Image src={HourGlass} inline className={"icon-align-middle"} />
      )}
      {row.name}
    </span>
  );

  loadData = (props) => {
    const rows = [];
    if (props.recs !== undefined) {
      _.forEach(props.recs, (element) => {
        const firstName = _.get(element, "FirstName[0]");
        const lastName = _.get(element, "LastName[0]");
        const jurisdiction = _.get(element, "Jurisdiction[0]");
        const cols = {
          crimCode: _.get(element, "crimRequest[0].crimCode[0]", ""),
          name: `${firstName !== undefined ? firstName : ""} ${
            lastName !== undefined ? lastName : ""
          }`,
          requestCode: _.get(element, "crimRequest[0].requestCode[0]", ""),
          reportType: getReportType(
            _.get(element, "crimRequest[0].requestCode[0]", "")
          ),
          crimStatus: _.get(element, "crimRequest[0].crimStatus[0]"),
          DrivLic: _.get(element, "DrivLic[0]", ""),
          ssn: _.get(element, "ssn[0]", ""),
          DateOfBirth: _.get(element, "DateOfBirth[0]", ""),
          jurisdiction:
            jurisdiction !== "" ? jurisdiction : _.get(element, "state[0]", ""),
          date:
            _.get(element, "crimRequest[0].crimStatus[0]") === "r"
              ? _.get(element, "crimRequest[0].crimUpdate[0]", "")
              : _.get(element, "crimRequest[0].crimCreated[0]", ""),
        };
        rows.push(cols);
      });
    }

    const columns = [
      {
        dataField: "reqStatus",
        text: "Subject",
        formatter: this.reportFormat,
        width: "15%",
        sort: true,
      },
      {
        dataField: "DrivLic",
        text: "Driver License",
        width: "30%",
        sort: true,
      },
      {
        dataField: "ssn",
        text: "SSN",
        width: "30%",
        sort: true,
      },
      {
        dataField: "DateOfBirth",
        formatter: this.dobFormat,
        text: "DOB",
        width: "10%",
        sort: true,
      },
      {
        dataField: "reportType",
        text: "Report",
        width: "10%",
        sort: true,
      },
      {
        dataField: "jurisdiction",
        text: "Jurisdiction",
        width: "15%",
        sort: true,
      },
      {
        dataField: "date",
        text: "Date/Time",
        width: "15%",
        sort: true,
      },
    ];
    if (this.state === undefined) {
      this.state = { rows, columns };
    } else {
      this.setState({ rows, columns });
    }
  };

  render() {
    if (this.state !== null && this.state.columns.length > 0) {
      return (
        <BootstrapTable
          data={this.state.rows}
          keyField={"crimCode"}
          columns={this.state.columns}
          pagination={paginationFactory()}
          striped
          hover
        />
      );
    }
    return null;
  }
}

export default OfflineMvrReportTable;



// WEBPACK FOOTER //
// ./src/components/myaccount/OfflineMvrReportTable.js